import { NetworkStatus } from '@apollo/client';
import { useEffect } from 'react';

export const useNetworkReadyEffect = (callback: () => void, networkStatus: NetworkStatus) =>
  useEffect(() => {
    // Only execute effect after network status returns to "ready" after a query
    if (networkStatus === NetworkStatus.ready) callback();
  }, [networkStatus]);
